import styled from 'styled-components';

// Styled text logo components
export const LogoContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;


